import { Toaster as Sonner, ToasterProps } from 'sonner';

const Toaster = (props: ToasterProps) => <Sonner richColors {...props} />;

export { Toaster };
